<script>
import {
  CurrentSubscriptionElementMixin,
} from "%/dynamic-component-editor/standard-components/current-subscription/current-subscription-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "CurrentSubscriptionNextBillingDate",
  elementPanelSettings: {
    displayName: "Current Subscription Next Billing Date",
    displayIcon: "calendar",
    elementGroup: "currentSubscriptionElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [CurrentSubscriptionElementMixin],
  computed: {
    value() {
      return this.formatSubscriptionDate(this.currentSubscription.next_billing_date);
    },
  },
};
</script>
